// @flow
import React, { useEffect, useState } from 'react';
// Composers
import { currentOrderNumberConnector } from '../../current-order';
// API
import Common from '../api';
// Styles
import './Alert.css';
// Other
import { phone } from '../../common';

const pingingInterval = 30000;

const Alert = ({ currentOrderNumber }) => {
  const [consecutiveFailures, setConsecutiveFailures] = useState(0);
  const [isPinging, setIsPinging] = useState(false)

  useEffect(() => {
    const ping = async () => {
      if (isPinging) return;
      setIsPinging(true);

      try {
        await Common.ping();
        setConsecutiveFailures(0);
      } catch (err) {
        console.warn('Error on Health Check', err)
        setConsecutiveFailures(prev => prev + 1);
      } finally {
        setIsPinging(false);
      }
    }

    ping();

    const timerId = setInterval(ping, pingingInterval);

    return () => clearInterval(timerId);
  }, []);

  if (consecutiveFailures >= 2) {
    return (
      <div className="alert-container">
        <div className="alert-main">
          Oops! Não estamos conseguindo conectar à internet. Se estiver com
          dificuldades em usar nosso site, ligue para {phone.asStringFull} e
          continuaremos o seu pedido #{currentOrderNumber} de onde você parou.
        </div>
      </div>
    );
  }

  return null;
};

export default currentOrderNumberConnector(Alert);
